import React from 'react'

import InviteSelect from 'components/shared/InviteSelect'

import './style.styl'

const SegmentSelect = ({ value, options, onNext, onCancel, onChange, isEmailPlaybook, showCancel = true }) => (
  <div className="playbook-segment-select">
    {showCancel && (
      <p className="link playbook-segment-cancel" onClick={onCancel}>
        &lt; Audiences
      </p>
    )}
    <h2>Which segments should {isEmailPlaybook ? 'receive this email' : 'see this Playbook'}?</h2>
    <h3>{isEmailPlaybook ? 'Send' : 'Display'} to people in the following segments:</h3>
    <InviteSelect
      onChange={onChange}
      value={value}
      options={options}
      optionRenderer={({ label }) => label}
      valueRenderer={({ label }) => label}
      selectOptions={{ filterOption: (option, filterText) => option.name.toLowerCase().includes(filterText) }}
      showInviteTips={false}
      shouldSelectAutofocus={false}
    />
  </div>
)

export default SegmentSelect



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SegmentSelect/component.js